import React from 'react';

function RegistrationActions({ registration, onAction, compact = false }) {
    const buttonClassName = compact ? 'registration-action-button compact' : 'registration-action-button';

    return (
        <div className={`registration-actions${compact ? ' compact' : ''}`}>
            {registration.status === 'pending' && (
                <>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'approved')}>
                        Approve
                    </button>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'waitlisted')}>
                        Waitlist
                    </button>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'rejected')}>
                        Reject
                    </button>
                </>
            )}

            {registration.status === 'approved' && (
                <>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'checked_in')}>
                        Check In
                    </button>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'waitlisted')}>
                        Waitlist
                    </button>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'cancelled')}>
                        Cancel
                    </button>
                </>
            )}

            {registration.status === 'waitlisted' && (
                <>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'approved')}>
                        Approve
                    </button>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'rejected')}>
                        Reject
                    </button>
                    <button type="button" className={buttonClassName} onClick={() => onAction(registration._id, 'cancelled')}>
                        Cancel
                    </button>
                </>
            )}
        </div>
    );
}

function RegistrationMobileCard({ registration, onAction }) {
    const displayName =
        registration.user?.profile?.displayName ||
        registration.user?.telegram?.firstName ||
        'Unknown';

    const style = registration.answers?.style || '-';
    const weight = registration.answers?.weight || '-';
    const status = String(registration.status || '').replace('_', ' ');

    return (
        <div className="registration-mobile-compact-card">
            <div className="registration-mobile-compact-top">
                <div className="registration-mobile-name">{displayName}</div>
                <div className="registration-mobile-status">{status}</div>
            </div>

            <div className="registration-mobile-meta">
                <span>{style}</span>
                <span>•</span>
                <span>{weight} kg</span>
            </div>

            <div style={{ marginTop: '0.75rem' }}>
                <RegistrationActions registration={registration} onAction={onAction} compact />
            </div>
        </div>
    );
}

function RegistrationDesktopTable({ registrations, onAction }) {
    return (
        <table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Style</th>
                    <th>KG</th>
                    <th>Status</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {registrations.length === 0 ? (
                    <tr>
                        <td colSpan="5" className="dim" style={{ textAlign: 'left' }}>
                            No registrations yet.
                        </td>
                    </tr>
                ) : (
                    registrations.map((registration) => {
                        const displayName =
                            registration.user?.profile?.displayName ||
                            registration.user?.telegram?.firstName ||
                            'Unknown';

                        return (
                            <tr key={registration._id}>
                                <td>{displayName}</td>
                                <td className="dim">{registration.answers?.style || '-'}</td>
                                <td>{registration.answers?.weight || '-'}</td>
                                <td>{String(registration.status || '').replace('_', ' ')}</td>
                                <td>
                                    <RegistrationActions registration={registration} onAction={onAction} />
                                </td>
                            </tr>
                        );
                    })
                )}
            </tbody>
        </table>
    );
}

function RegistrationTable({ registrations = [], loading, selectedEventId, onRefresh, onAction }) {
    const safeRegistrations = Array.isArray(registrations) ? registrations : [];

    if (loading) {
        return <div className="loader">FETCHING REGISTRATIONS...</div>;
    }

    return (
        <div className="fighter-list-admin">
            <div className="admin-header">
                <h3>REGISTRATIONS ({safeRegistrations.length})</h3>
                <button
                    type="button"
                    onClick={onRefresh}
                    className="refresh-btn"
                    disabled={!selectedEventId}
                >
                    ↻
                </button>
            </div>

            <div className="registration-table-desktop">
                <RegistrationDesktopTable registrations={safeRegistrations} onAction={onAction} />
            </div>

            <div className="registration-table-mobile">
                {safeRegistrations.length === 0 ? (
                    <div className="dim" style={{ textAlign: 'left' }}>
                        No registrations yet.
                    </div>
                ) : (
                    safeRegistrations.map((registration) => (
                        <RegistrationMobileCard
                            key={registration._id}
                            registration={registration}
                            onAction={onAction}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default RegistrationTable;